import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Styles/navMenuItem.module.css';

const NavMenuItem = (props) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    // If custom onClick is provided, use it
    if (props.onClick) {
      props.onClick(e);
      return;
    }

    // Normal menu navigation
    if (props.goto) {
      navigate(props.goto);
    }

    if (props.setSliderBarLocation) {
      props.setSliderBarLocation(e.clientY);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${props.iconOnly ? styles.item : styles.hiddenText} ${
        props.current ? styles.currentOption : ''
      }`}
      style={{ backgroundColor: props.backgroundColor }}
    >
      <div
        className={`${props.current ? styles.iconCurrent : ''} ${
          styles.itemIcon
        }`}
      >
        {props.icon}
      </div>

      {props.iconOnly ? (
        <div className={styles.itemText}>{props.text}</div>
      ) : null}
    </button>
  );
};

export default NavMenuItem;
